import cookie from "react-cookies";

/** Persist track-order auth so in-app trip chat works (Footer + track-order). */
export function persistOrderTrackSession(trackData, { email, orderid } = {}) {
  const oid = trackData?.orderid || orderid;
  const em = trackData?.email || email;
  const token = trackData?.token;
  if (!oid || !token) return;

  try {
    if (em) {
      cookie.save("currentOrder", `email=${em}&orderid=${oid}`, {
        path: "/",
        maxAge: 86400,
        secure: true,
      });
    }
    cookie.save("quotetoken", token, {
      path: "/",
      maxAge: 86400,
      secure: true,
    });
    cookie.save("usr-id-qt", token, {
      path: "/",
      maxAge: 5 * 60 * 1000,
      secure: true,
      domain: ".qiktruck.co.za",
    });
    localStorage.setItem("orderid", oid);
    localStorage.setItem("local-notifications", String(0));
  } catch (_) {
    /* cookies / storage may be blocked */
  }
}
